<template>
    <div class="modal-wrapper">
        <div class="modal-header">
            <h4>{{ $t("labels.areaChoose") }}</h4>
            <span @click="closeModal" class="fas fa-times"></span>
        </div>
        <div class="inner-container">
            <div class="form-group">
                <label>{{ $t("labels.mainAreaChoose") }}</label>
                <div class="areas-wrapper">
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: mainArea === CITY_ASPHALT_ID }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/areas/miasto_asfalt.jpg`)"
                             alt="Miasto/asfalt"
                             :class="{
                selected: mainArea === CITY_ASPHALT_ID,
              }"
                             @click="selectMainArea(CITY_ASPHALT_ID)" />
                        <span>{{ $t("labels.cityAsphalt") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: mainArea === FOREST_ROADLESS_ID }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/areas/lasy_bezdroza.jpg`)"
                             alt="Las/bezdroża"
                             :class="{
                selected: mainArea === FOREST_ROADLESS_ID,
              }"
                             @click="selectMainArea(FOREST_ROADLESS_ID)" />
                        <span>{{ $t("labels.forestRoadless") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: mainArea === GRAVEL_OTHERS_ID }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/areas/szutry_inne.png`)"
                             alt="Szutry/inne drogi"
                             :class="{
                selected: mainArea === GRAVEL_OTHERS_ID,
              }"
                             @click="selectMainArea(GRAVEL_OTHERS_ID)" />
                        <span>{{ $t("labels.gravelOthers") }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="inner-container">
            <div class="form-group">
                <label>{{ $t("labels.optionalAreaChoose") }}</label>
                <div class="areas-wrapper">
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: optionalAreas.includes(CITY_ASPHALT_ID) }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/areas/miasto_asfalt.jpg`)"
                             alt="Miasto/asfalt"
                             :class="{
                selected: optionalAreas.includes(CITY_ASPHALT_ID),
                disabled: mainArea === CITY_ASPHALT_ID,
              }"
                             @click="selectOptionalArea(CITY_ASPHALT_ID)" />
                        <span>{{ $t("labels.cityAsphalt") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: optionalAreas.includes(FOREST_ROADLESS_ID) }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/areas/lasy_bezdroza.jpg`)"
                             alt="Las/bezdroża"
                             :class="{
                selected: optionalAreas.includes(FOREST_ROADLESS_ID),
                disabled: mainArea === FOREST_ROADLESS_ID,
              }"
                             @click="selectOptionalArea(FOREST_ROADLESS_ID)" />
                        <span>{{ $t("labels.forestRoadless") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: optionalAreas.includes(GRAVEL_OTHERS_ID) }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/areas/szutry_inne.png`)"
                             alt="Szutry/inne drogi"
                             :class="{
                selected: optionalAreas.includes(GRAVEL_OTHERS_ID),
                disabled: mainArea === GRAVEL_OTHERS_ID,
              }"
                             @click="selectOptionalArea(GRAVEL_OTHERS_ID)" />
                        <span>{{ $t("labels.gravelOthers") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    // vuex
    import { mapFields } from "vuex-map-fields";

    // methods
    import updateUrlParams from "@/router/middleware/updateUrlParamsMiddleware";
    import setCookie from "@/utils/setCookie";

    // css
    import "./Modal.scss";

    export default {
        name: "AreaModal",
        props: {
            areas: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                // Get IDs of areas in Database.
                CITY_ASPHALT_ID: this.areas.filter((el) => el.Text === "Miasto/asfalt")[0].Value,
                FOREST_ROADLESS_ID: this.areas.filter((el) => el.Text === "Lasy/bezdroża")[0].Value,
                GRAVEL_OTHERS_ID: this.areas.filter((el) => el.Text === "Szutry/inne drogi")[0].Value,
            };
        },
        computed: {
            ...mapFields(["filters.mainArea", "filters.optionalAreas"]),
        },
        watch: {
            mainArea: function (newVal) {
                setCookie("mainArea", +newVal, this);
                updateUrlParams();
            },
            optionalAreas: function (newVal) {
                setCookie("optionalAreas", newVal.join(), this);
                updateUrlParams();
            },
        },
        methods: {
            closeModal() {
                this.$emit("closeModal");
            },
            selectMainArea(area) {
                // If clicked area is already set as optional, remove it and set as main.
                // If clicked area is already set as main, unclick it.
                if (this.optionalAreas.includes(area)) {
                    const index = this.optionalAreas.indexOf(area);
                    if (index > -1) {
                        this.optionalAreas.splice(index, 1);
                    }
                }
                if (this.mainArea === area) {
                    this.mainArea = null;
                } else {
                    this.mainArea = area;
                }
            },
            selectOptionalArea(area) {
                // If selected area is already set as main, do nothing.
                // If selected area is already in optional areas remove it.
                if (this.mainArea === area) return;
                if (this.optionalAreas.includes(area)) {
                    const index = this.optionalAreas.indexOf(area);
                    if (index > -1) {
                        this.optionalAreas.splice(index, 1);
                    }
                } else {
                    this.optionalAreas.push(area);
                }
            },
            getCookies() {
                // Get main area value from cookies
                const mainArea = this.$cookies.get("mainArea");
                if (mainArea != null && mainArea != "") this.mainArea = +mainArea;

                // Get optional areas values from cookies
                const optionalAreas = this.$cookies.get("optionalAreas");
                if (optionalAreas) {
                    let cookieOptionalAreas = optionalAreas.split(",");
                    if (cookieOptionalAreas) {
                        for (let i = 0; i < cookieOptionalAreas.length; i++) {
                            cookieOptionalAreas[i] = +cookieOptionalAreas[i];
                        }
                        this.optionalAreas = cookieOptionalAreas;
                    }
                }
            },
        },
        mounted() {
            this.getCookies();
        },
    };
</script>
